import React from 'react'

import { useIntl } from 'react-intl'

import Text from 'app/components/base/Text'
import { auctionReserveText } from 'app/utils/constants/auction.constants'

interface ReserveInfoProps {
  reserveStatus?: string
}

const ReserveInfo: RFC<ReserveInfoProps> = ({ reserveStatus }) => {
  const intl = useIntl()

  const reserveMessage = !!reserveStatus
    ? auctionReserveText[reserveStatus]
    : auctionReserveText.no_reserve

  return (
    <Text variant="subtitle2" component="p" sx={{ fontWeight: 500 }}>
      {intl.formatMessage(reserveMessage)}
    </Text>
  )
}

export default ReserveInfo
